<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Банковские реквизиты выгодоприобретателя<br class="onlydesk"> для получателя выплаты</h3>
      <TextInput @setError="errors.receiver = $event" v-model="form.bankdata.receiver" text="ФИО получателя выплаты (выгодоприобретателя):" name="bankdata-receiver" />
      <NumberInput mask="#########" :filled="(v) => v.length == 9" @setError="errors.BIK = $event" v-model="form.bankdata.BIK" text="БИК банка получателя:" name="bankdata-BIK" />
      <TextInput :disabled="true" @setError="errors.bankname = $event" v-model="form.bankdata.bankname" text="Наименование банка:" name="bankdata-bankname" />
      <TextInput @setError="errors.accountNumber = $event" v-model="form.bankdata.accountNumber" text="Номер лицевого счета получателя:" name="bankdata-accountNumber" />
      <CheckBox :smtext="true" name="bankdata-confirm" v-model="form.bankdata.confirm">
        Подтверждаю ознакомление с
        <a :href="agreementlink1">соглашением</a> о порядке электронного взаимодействия и даю согласие на обработку и передачу
        <a :href="agreementlink2">персональных данных</a>.
      </CheckBox>
      <Btn class="step__next" :disabled="!filled" @click="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import { mapState } from 'vuex';
import TextInput from '../inputs/TextInput.vue';
import CheckBox from '../inputs/CheckBox.vue';
import NumberInput from '../inputs/NumberInput.vue';

export default {
  components: { Btn, TextInput, CheckBox, NumberInput },
  props: {
    active: { type: Boolean }
  },
  data: () => ({
    errors: {},
    agreementlink1: './',
    agreementlink2: './',
  }),
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      let required = ['receiver', 'BIK', 'bankname', 'accountNumber', 'confirm']
      for (let key of required)
        if (!this.form.bankdata[key]) return false

      return true
    }
  },
  watch: {
    'form.bankdata.BIK': async function (v) {
      if (v.length == 9) {
        var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank"
        var token = this.$store.state.DaDataToken
        var query = v;

        var options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + token
          },
          body: JSON.stringify({ query: query })
        }

        fetch(url, options)
          .then(response => response.json())
          .then(result => this.form.bankdata.bankname = result.suggestions[0].value )
          .catch(error => console.log("error", error))
      }
    }
  }
}
</script>

<style lang="sass">

</style>